import { Card, Col, Row } from "antd";
import React from "react";
import PropTypes from "prop-types";

const PackageViewForDepoManager = ({ packageDetailsViewNew }) => {
  const packageDetailsView = packageDetailsViewNew?.data[0];
  const warehouseDetails = packageDetailsViewNew?.other_details[0];

  return (
    <>
      {packageDetailsView ? (
        <>
          <div style={{ maxWidth: "870px", margin: "0 auto" }}>
            <Row gutter={16} style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {/* Customer Details */}
              <div
                style={{ 
                  flex: "1 1 calc(50% - 16px)", // Two items per row
                  minHeight: "200px", // Adjust as needed for consistent height
                  backgroundColor: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  border: "2px solid black",
                  marginBottom: "15px"
                }} 
              >
                <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "16px" }}>Customer Details</h2>
                <p><strong>Company:</strong> {packageDetailsView.company_name || "N/A"}</p>
                <p><strong>HAWB:</strong> {packageDetailsView.hawb || "N/A"}</p>
                <p><strong>Customer Code:</strong> {packageDetailsView.customer_code || "N/A"}</p>
                <p><strong>Customer Name:</strong> {packageDetailsView.customer_name || "N/A"}</p>
                <p><strong>Customer Number:</strong> {packageDetailsView.customer_phone || "N/A"}</p>
                <p><strong>Customer Email:</strong> {packageDetailsView.customer_email || "N/A"}</p>
                <p><strong>Status:</strong> {packageDetailsView.status || "N/A"}</p>
              </div>

              {/* Address Details */}
              <div
                style={{ 
                  flex: "1 1 calc(50% - 16px)", // Two items per row
                  minHeight: "200px", // Same height as above
                  backgroundColor: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  border: "2px solid black",
                  marginBottom: "15px"
                }}
              >
                <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "16px" }}>Address Details</h2>
                <p><strong>Street Address:</strong> {packageDetailsView.customer_address || "N/A"}</p>
                <p><strong>Country:</strong> {packageDetailsView.country_name || "N/A"}</p>
                <p><strong>State:</strong> {packageDetailsView.state_name || "N/A"}</p>
                <p><strong>Zone:</strong> {packageDetailsView.zone_name || "N/A"}</p>
                <p><strong>Suburb:</strong> {packageDetailsView.suburb_name || "N/A"}</p>
                <p><strong>Postcode:</strong> {packageDetailsView.postcode_name || "N/A"}</p>
              </div>
            </Row>

            <Row gutter={16} style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {/* Package Data */}
              <div
                style={{
                  flex: "1 1 calc(50% - 16px)", // Two items per row
                  minHeight: "200px", // Same height
                  backgroundColor: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  border: "2px solid black",
                }}
              >
                <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "16px" }}>Package Data</h2>
                <p><strong>Description Goods:</strong> {packageDetailsView.description_of_goods || "N/A"}</p>
                <p><strong>Count:</strong> {packageDetailsView.count || "N/A"}</p>
                <p><strong>Landed:</strong> {packageDetailsView.landed !== undefined ? packageDetailsView.landed.toString() : "N/A"}</p>
                <p><strong>Weight:</strong> {packageDetailsView.weight || "N/A"}</p>
                <p><strong>Price:</strong> {packageDetailsView.price || "N/A"}</p>
                <p><strong>Height:</strong> {packageDetailsView.height || "N/A"}</p>
                <p><strong>Length:</strong> {packageDetailsView.length || "N/A"}</p>
                <p><strong>Volume Weighted:</strong> {packageDetailsView.volume_weighted || "N/A"}</p>
              </div>

              {/* Warehouse Details */}
              <div
                style={{
                  flex: "1 1 calc(50% - 16px)", // Two items per row
                  minHeight: "200px", // Same height
                  backgroundColor: "white",
                  padding: "16px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  border: "2px solid black",
                }}
              >
                <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "16px" }}>Warehouse Details</h2>
                <p><strong>Return To Depo Time:</strong> {warehouseDetails.return_status_change_at || "N/A"}</p>
                <p><strong>Depo Manager Name:</strong> {warehouseDetails.warehouse_person_name || "N/A"}</p>
                <p><strong>Email:</strong> {warehouseDetails.warehouse_email || "N/A"}</p>
                <p><strong>Warehouse Address:</strong> {warehouseDetails.warehouse_street_address || "N/A"}</p>
                <p><strong>Warehouse Latitude:</strong> {warehouseDetails.warehouse_latitude || "N/A"}</p>
                <p><strong>Warehouse Longitude:</strong> {warehouseDetails.warehouse_longitude || "N/A"}</p>
              </div>
            </Row>

            {/* Time Window */}
            <div
              style={{
                backgroundColor: "white",
                padding: "16px", 
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                border: "2px solid black",
                marginTop: "16px",
                marginLeft: "-8px",
                marginRight: "-8px",
              }}
            >
              <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "16px" }}>Time Window</h2>
              <p><strong>Created Date:</strong> {packageDetailsView.created_at || "N/A"}</p>
            </div>
          </div>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

PackageViewForDepoManager.propTypes = {
  packageDetailsViewNew: PropTypes.object, // Expecting an object
};

export default PackageViewForDepoManager;
